module.exports = __webpack_public_path__ + "static/media/permanent-make-up.2d83e42a.jpg";